import type { Notification } from '../types/notification';
import { NotificationType } from '../types/notification';

export const mockNotifications: Notification[] = [
    {
        id: 1,
        timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(), // 2 hours ago
        read: false,
        delivered: false,
        tipo: NotificationType.PATTERN_ALERT,
        messaggio: {
            ticker: 'XAUUSD',
            timeframe: 'M1',
            timestamp: '2025-06-03T10:22:09.989601+00:00',
            pattern_unique_id: '1737694920_XAUUSD_M1_3_0.15',
            timestamp_end_subpattern_live: 1747155720,
            timestamp_start_subpattern_live: 1747155600,
        },
    },
    {
        id: 2,
        timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5).toISOString(), // 5 hours ago
        read: false,
        delivered: false,
        tipo: NotificationType.PATTERN_ALERT,
        messaggio: {
            ticker: 'XAUUSD',
            timeframe: 'M1',
            timestamp: '2025-06-03T10:22:09.971612+00:00',
            pattern_unique_id: '1737694920_XAUUSD_M1_3_0.2',
            timestamp_end_subpattern_live: 1747155720,
            timestamp_start_subpattern_live: 1747155600,
        },
    },
    {
        id: 3,
        timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(), // 1 day ago
        read: true,
        delivered: true,
        tipo: NotificationType.PATTERN_ALERT,
        messaggio: {
            ticker: 'XAUUSD',
            timeframe: 'M1',
            timestamp: '2025-06-03T10:22:09.958604+00:00',
            pattern_unique_id: '1737694920_XAUUSD_M1_3_0.1',
            timestamp_end_subpattern_live: 1747155720,
            timestamp_start_subpattern_live: 1747155600,
        },
    },
];
